<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!--title -->
        <div class="grid-title no-border borderTop">
          <h4 style="padding-left: 6px"> {{ i18nValues["supplierEdition"] }} </h4>
        </div>        
  
        <!-- body -->
        <div class="grid-body no-border borderBottom">
          <el-form v-loading="loading != 0" :model="supplier" ref="formSupplier" :rules="rules">
            <div class="gridTemplate">
  
                <!-- Name -->    
                <el-form-item :label="i18nValues['name']" prop="name"> 
                  <el-input v-model="supplier.name" maxlength="30"></el-input>
                </el-form-item>                    
  
                <!-- Address -->    
                <el-form-item :label="i18nValues['address']" prop="address"> 
                  <el-input v-model="supplier.address" maxlength="30"></el-input>
                </el-form-item> 
  
                <!-- City -->
                <el-form-item :label="i18nValues['city']" prop="city"> 
                  <el-input v-model="supplier.city" maxlength="30"></el-input>
                </el-form-item>
  
                <!-- State -->
                <el-form-item :label="i18nValues['state']" prop="state"> 
                  <el-input v-model="supplier.state" maxlength="30"></el-input>
                </el-form-item>
  
                <!-- Zip Code -->
                <el-form-item :label="i18nValues['zipCode']" prop="zipCode"> 
                  <el-input v-model="supplier.zipCode" maxlength="30"></el-input>
                </el-form-item>
  
                <!-- Country -->
                <el-form-item :label="i18nValues['country']" prop="country"> 
                  <el-input v-model="supplier.country" maxlength="30"></el-input>
                </el-form-item>
  
                <!-- Phone -->
                <el-form-item :label="i18nValues['phone']" prop="phone"> 
                  <el-input v-model="supplier.phone" maxlength="30"></el-input>
                </el-form-item>
  
                <!-- Contact -->
                <el-form-item :label="i18nValues['contact']" prop="contact"> 
                  <el-input v-model="supplier.contact" maxlength="30"></el-input>
                </el-form-item>
  
            </div>          
          </el-form>
  
          <!-- CANCEL/SAVE --> 
          <div class="full-width d-flex justify-content-end mt-2">
            <el-button :loading="loading" size="small" @click="cancel()">
              {{ i18nValues["cancel"] }}
            </el-button>
            <el-button v-if="!isReadOnly()" icon="fas fa-check" :loading="loading" size="small" class="btn-primary" @click="save()">
              {{ i18nValues["save"] }}
            </el-button>
          </div>  
  
        </div>      
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  export default {
    name: "SupplierEdition",  
  
    created(){
  
      if(this.id != 0 ){
          this.retrieveById();
      } else {
        this.supplier.creationUser = this.user.name;
        this.supplier.creationDate = new Date();
      }
  
      this.rules= {
        name:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
      };

    // Capture initial query to preserve filters/pagination when returning
    this.returnQuery = { ...this.$route.query };
  
    },
  
    components: {
      
    },
  
    computed: {
      loading: get("supplier/loading"),
    },
  
    props:["id"],
  
    data() {
      return {
  
        supplier: {},
  
      rules:{},
      returnQuery: {},
  
      };
    },
  
    methods: {
      save(){
        this.$refs["formSupplier"].validate(valid => {
          if(valid){
            this.$store.dispatch("supplier/saveSupplier", this.supplier).then((res) =>{            
              if(res.status == "OK"){
                  this.$notify.success({
                      title: this.i18nValues["succes"],
                      message: this.i18nValues["supplierSaved"],
                      position: "bottom-right",
                  });      
                  this.$router.push({name:"SupplierAdmin", query: this.returnQuery});    
              } else {
                  this.$notify.error({
                      title: this.i18nValues["error"],
                      message: this.i18nValues["SupplierSavedError"],
                      position: "bottom-right",
                  });
              }           
            });
          }
        });
      },
  
      cancel(){
          this.$router.push({name:"SupplierAdmin", query: this.returnQuery});
      },
  
      retrieveById(){
          this.$store.dispatch("supplier/retrieveSupplierById", { id: this.id }).then((res)=>{
              this.supplier = res;
              this.supplier.modificationUser = this.user.name;
              this.supplier.modificationDate = new Date();
          });       
      },
    },
  
  
  }
  </script>
  
  <style>
  
  </style>